import labelTemplates from './defaultLabelTemplates';
import rowTemplateThresholds from './defaultRowTemplateThresholds';

export default {
	decimal: '.',
	thousands: ',',
	grouping: [3],
	currency: ['$', ''],
	dateTime: '%a %b %e %X %Y', // %c
	time: '%H:%M', // 24-hour format
	periods: ['am', 'pm'], // %p
	date: '%-m/%-d/%Y', // %x
	days: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'], // %A
	shortDays: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'], // %a
	months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'], // %B
	shortMonths: ['janv', 'fév', 'mars', 'avr', 'mai', 'juin', 'juill', 'août', 'sept', 'oct', 'nov', 'déc'], // %b
	translations: {
		band: {
			overbought: 'Sur-achat',
			oversold: 'sur-vente'
		},
		chart: {
			unavailable: 'Graphique non disponible'
		},
		indicator: {
			previousclose: {
				label: 'Prix ​​précédent {0}'
			}
		}
	},
	labelTemplates,
	rowTemplateThresholds
};
